import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgOppLocation = (props) => /* @__PURE__ */ _jsx("svg", {
	height: "100px",
	width: "100px",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 90 90",
	style: { enableBackground: "new 0 0 90 90" },
	xmlSpace: "preserve",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M44.3,8.5c-13.6,0-24.7,11.1-24.7,24.7c0,0.4,0,0.9,0,1.3l0.1,2c0.4,2.1,1.3,5.7,3.3,10.8c3,7.4,9.1,19.3,21.4,35  c5.8-8,22.7-32.2,24.2-44.9l0-0.1c0.2-1.3,0.3-2.7,0.3-4.1C69,19.6,57.9,8.5,44.3,8.5z M44.2,44.2c-6,0-10.9-4.9-10.9-10.9  c0-6,4.9-10.9,10.9-10.9c6,0,10.9,4.9,10.9,10.9C55.1,39.3,50.2,44.2,44.2,44.2z" })
});
export default SvgOppLocation;
